export default __webpack_public_path__ + "static/media/new_header.4fb72705.svg";